<div class="{{ sectionclass }} platform-performance">
	<app-loader [showLoader]="showLoad"></app-loader>
	<!-- content to be render if we have data -->
	<div *ngIf="hasData">
		<div class="table-header">
			<div></div>
			<div>started</div>
			<div>25% completed</div>
			<div>50% completed</div>
			<div>75% completed</div>
			<div>100% completed</div>
		</div>
		<div
			class="table-content"
			*ngFor="let row of tableData | paginate: { id: 'pagination', itemsPerPage: 8, currentPage: pageId }"
		>
			<div class="first column">
				<p class="name">{{ row.name }}</p>
				<p class="impressions">{{ row.impressions | number }}</p>
				<p class="impressions-text">impressions</p>
			</div>

			<div class="column">
				<div class="header">100%</div>
				<div class="progress-bar first"></div>
				<div class="footer"></div>
			</div>

			<div class="column">
				<div class="header">{{ row.percent25 }}%</div>
				<div class="progress-bar"></div>
				<div class="footer">{{ row.value25 | number }} views</div>
			</div>

			<div class="column">
				<div class="header">{{ row.percent50 }}%</div>
				<div class="progress-bar"></div>
				<div class="footer">{{ row.value50 | number }} views</div>
			</div>

			<div class="column">
				<div class="header">{{ row.percent75 }}%</div>
				<div class="progress-bar"></div>
				<div class="footer">{{ row.value75 | number }} views</div>
			</div>

			<div class="column">
				<div class="header">{{ row.percent100 }}%</div>
				<div class="progress-bar"></div>
				<div class="footer">{{ row.value100 | number }} views</div>
			</div>
		</div>

		<!-- pagination template -->
		<pagination-template #p="paginationApi" (pageChange)="pageId = $event" id="pagination" class="pagination">
			<ul class="pager">
				<li [class.disabled]="p.isFirstPage()" style="float: left;" class="firstArrow">
					<a (click)="p.setCurrent(1)"><span>First</span> </a>
				</li>

				<li
					role="button"
					*ngFor="let page of p.pages"
					[class.current]="p.getCurrent() === page.value"
					class="pages"
					style="float: left;"
				>
					<a (click)="p.setCurrent(page.value)" *ngIf="p.getCurrent() !== page.value">{{ page.label }}</a>
					<a *ngIf="p.getCurrent() === page.value"> {{ page.label }}</a>
				</li>

				<li [class.disabled]="p.isLastPage()" style="float: left;" class="lastArrow">
					<a (click)="p.setCurrent(p.getLastPage())"> <span>Last</span></a>
				</li>
			</ul>
		</pagination-template>
	</div>

	<!-- no data container-->
	<div *ngIf="!hasData" class="no-data-container">
		<div class="message">No Data Available</div>
	</div>
</div>
